import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import IImageRecognitionComponent from '@components/FormFlow/Interfaces/FormflowComponents/IImageRecognitionComponent';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import React from 'react';
import ProcessContext from '../ProcessContext';
import { Input, Button } from 'antd'
import QuillHtmlComponent from '@components/QuillHtmlEditorComponent';
import ImageRecognitionModalComponentProcess from '@components/process/components/ImageRecognitionModalComponentProcess'

interface ConfigurationItems {
  code: any;
  name: string;
  quantityMin: number;
  quantityMax: number;
  errorMessage: string;
  successMessage: string;
  partialMessage: string;
}

interface IImageRecognitionTaskComponentStateType {
  showModal: boolean,
  projectId: number|null;
  modelId: number|null;
  authenticationKey: string;
  configurationItems: Array<ConfigurationItems>;
};

export class ImageRecognitionComponent implements IImageRecognitionComponent {
  id: string;
  type: ComponentType;
  title: string;
  description?: string;
  required: boolean;
  showModal: boolean;
  projectId: number|null;
  modelId: number|null;
  authenticationKey: string;
  configurationItems: Array<ConfigurationItems>;
  repeat: any;

  constructor(id: string = '') {
    this.id = id;
    this.type = ComponentType.IMAGERECOGNITION;
    this.title = '';
    this.required = false;
    this.showModal = false;
    this.projectId = null;
    this.modelId = null
    this.authenticationKey = '';
    this.configurationItems = [];
    this.repeat = true;

    return this;
  }
}

export default class ImageRecognitionComponentProcess extends React.Component<IImageRecognitionComponent, IImageRecognitionTaskComponentStateType> {
  constructor(props: IImageRecognitionComponent) {
    super(props);

    this.state = {
      showModal: false,
      projectId: this.props.projectId || null,
      modelId: this.props.modelId || null,
      authenticationKey: this.props.authenticationKey || '',
      configurationItems: this.props.configurationItems || [],
    };

    this.handleProjectIdChange = this.handleProjectIdChange.bind(this)
    this.handleModelIdChange = this.handleModelIdChange.bind(this)
    this.handleAuthenticationKeyChange = this.handleAuthenticationKeyChange.bind(this)
    this.setConfigurationItems = this.setConfigurationItems.bind(this)
    this.handleToggleModal = this.handleToggleModal.bind(this)
  }

  onSave(updateFormflowWithComponent: (component: IBaseComponent) => void) {
    const { projectId, modelId, authenticationKey, configurationItems } = this.state
    const newImageRecognitionDataComponent: any = { projectId, modelId, authenticationKey, configurationItems }

    updateFormflowWithComponent(newImageRecognitionDataComponent);
  }

  handleProjectIdChange(e: any) {
    this.setState({ projectId: e.target.value })
  }

  handleModelIdChange(e: any) {
    this.setState({ modelId: e.target.value })
  }

  handleAuthenticationKeyChange(e: any) {
    this.setState({ authenticationKey: e.target.value })
  }
  setConfigurationItems(items: Array<ConfigurationItems>) {
    this.setState({ configurationItems: items })
  }

  handleToggleModal() {
    const { showModal } = this.state
    this.setState({ showModal: !showModal })
  }

  render() {
    const {
      showModal,
      projectId, 
      modelId, 
      authenticationKey, 
      configurationItems 
    } = this.state

    return (
      <div>
        <CardConfig style={{ marginTop: '25px' }}>
          {I18n.l('label.projectId')} <LabelRequired>* {I18n.l('formflow.labels.required')}</LabelRequired>
          <div>
            <Input
              onChange={this.handleProjectIdChange}
              value={projectId || ''}
              style={{ marginTop: '10px' }}
              placeholder={I18n.l('label.components.writeHere')}
            />
          </div>
        </CardConfig>
        <DividerBorder />

        <CardConfig style={{ marginTop: '25px' }}>
          {I18n.l('label.modelId')} <LabelRequired>* {I18n.l('formflow.labels.required')}</LabelRequired>
          <div>
            <Input
              onChange={this.handleModelIdChange}
              value={modelId || ''}
              style={{ marginTop: '10px' }}
              placeholder={I18n.l('label.components.writeHere')}
            />
          </div>
        </CardConfig>
        <DividerBorder />

        <CardConfig style={{ marginTop: '25px' }}>
          {I18n.l('label.authenticationKey')} <LabelRequired>* {I18n.l('formflow.labels.required')}</LabelRequired>
          <div>
            <Input
              onChange={this.handleAuthenticationKeyChange}
              value={authenticationKey || ''}
              style={{ marginTop: '10px' }}
              placeholder={I18n.l('label.components.writeHere')}
            />
          </div>
        </CardConfig>
        <DividerBorder />

        <CardConfig>
          <div style={{ marginTop: '25px' }}>
            {I18n.l('label.itemsConfigurationMsg')}
          </div>
          <div style={{ marginTop: '25px' }}>
            <Button onClick={this.handleToggleModal}>{I18n.l('label.itemsConfiguration')}</Button>
          </div>
        </CardConfig>
      
        <ProcessContext.Consumer>
          {({ updateProcessComponent }) => (
            <>
              {this.onSave(updateProcessComponent)}
            </>
          )}
        </ProcessContext.Consumer>

        {showModal && <ImageRecognitionModalComponentProcess
          isVisible={showModal}
          configurationItems={configurationItems}
          onSetConfigurationItems={this.setConfigurationItems}
          onToggleModal={this.handleToggleModal}
        />}
      </div>
    );
  }
}

const CardConfig = styled.div`
  padding-bottom: 25px;
  height:auto;
  background-color: #F6FCFD;
  .quill {
    background: white;
  }
`;

const DividerBorder = styled.div`
    border-bottom: 1px solid  ${Theme.secondary.lightGrey};
    width: 120%;
    margin-left: -29px;
`;

const LabelRequired = styled.sup`
  color : red
`